import { useQuery } from "@tanstack/react-query";

import { getFootprintingDairyGrasslandFertiliser, getFootprintingDairyGrasslandFertiliserAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_DAIRY_GRASSLAND_FERTILISER } from "consts";

export const useGetFootprintingDairyGrasslandFertiliser = (primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;

  return useQuery({
    queryKey: [FOOTPRINTING_DAIRY_GRASSLAND_FERTILISER, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getFootprintingDairyGrasslandFertiliserAdmin(primaryDataId ?? "") : getFootprintingDairyGrasslandFertiliser(primaryDataId ?? "")),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
